require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./tags-substance-use-treatment.json") })
        }
      }, "path---tags-substance-use-treatment");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---tags-substance-use-treatment!./.cache/json/tags-substance-use-treatment.json
// module id = 1043
// module chunks = 231608221292675